import * as yup from "yup";

export const validatePaymentReceipt = yup.object({
  voucher_date: yup
    .string()
    .required("Voucher Date  is required")
    .nonNullable("Voucher Date is required"),

  reference_number: yup.string().optional().nullable(),
  reference_date: yup.string().optional().nullable(),
  amount: yup.string().required("Amount is required"),
  account: yup.string().required("Account is required"),
  party_account: yup.string().required("Ledger Account is required"),
  number_series: yup.string().required("Number Series is required"),
  entry_number: yup.string().required("Entry Number is required"),
});
